import React from 'react'
import { Helmet } from 'react-helmet-async';
import Header1 from '../components/Header1'
import Footer from '../components/Footer'
import BreadcrumbMql from '../components/BreadcrumbMql'
import MqlComponent from '../components/MqlComponent'
import MqlFeatures from '../components/MqlFeatures'
import MqlBenefits from '../components/MqlBenefits'
import VvlComponent from '../components/VvlComponent'
import Vvladvantage from '../components/VvlAdvantage'
import CtaMql from '../components/CtaMql'

export default function DemandGen() {
  return (
    <div>
       <Helmet>
          <title>Demand Gen | Voice Verified Leads | ProPlus Data</title>
          <meta name="description" content="Drive performance with ProPlus Data’s MQL solutions. Leverage voice-verified, intent-backed leads to accelerate conversions and fuel GTM success."/>
          <meta name="keywords" content="Marketing-Qualified Leads, Lead Qualification Matrix, Targeted Lead Adoption, A/B Testing, Voice-Verified Leads, Lead Verification, ROI Optimization, Prospect Allocation, Sales Engagement, Key KPI Indicators, Tailored Content, Lead Conversion"/>
          <link rel="canonical" href="https://proplusdata.co/marketing-qualified-leads"/>                                     
          <meta property="og:url" content="https://proplusdata.co/marketing-qualified-leads" />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="Marketing Qualified Leads | Voice Verified Leads | ProPlus Data " />
          <meta property="og:description"
                content="Drive performance with ProPlus Data’s MQL solutions. Leverage voice-verified, intent-backed leads to accelerate conversions and fuel GTM success." />
        </Helmet>
      <Header1/>
      <BreadcrumbMql/>
      <MqlComponent/>
      <MqlFeatures/>
      <MqlBenefits/>
      <VvlComponent/>
      <Vvladvantage/>
      <CtaMql/>
      <Footer/>
      <div class="btnwhatsapp-sm">
        <a target="_blank" rel="noreferrer" href="https://wa.me/+919112110691"><i class="fa fa-whatsapp"></i></a>
    </div>
    </div>
  )
}
